var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCleanIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1451 5.86914V7.05914L20.1451 7.45414V4.86914H17.6401L18.0351 5.86914H19.1451Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.145 10.0491V18.8691H6.14502V5.86914H15.15L15.54 4.86914H5.14502V19.8691H20.145V9.65414L19.145 10.0491Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 4.93555L15.565 7.53055L12.97 8.55555L15.565 9.58055L16.59 12.1755L17.615 9.58055L20.21 8.55555L17.615 7.53055L16.59 4.93555Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.795 6.76094L10.24 8.55594L14.795 10.3509L16.59 14.9009L18.385 10.3509L19.145 10.0509L20.145 9.65594L22.935 8.55594L20.145 7.45594L19.145 7.06094L18.385 6.76094L18.035 5.87094L17.64 4.87094L16.59 2.21094L15.54 4.87094L15.145 5.87094L14.795 6.76094ZM20.21 8.55594L17.615 9.58094L16.59 12.1759L15.565 9.58094L12.97 8.55594L15.565 7.53094L16.59 4.93594L17.615 7.53094L20.21 8.55594Z",
    fill: "#1D1D1B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCleanIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clean_icon.bd701287c3bb3dec9cb77f874302bda8.svg";